import { useState } from 'react';

import type { UserTargetingProps } from 'hb-react/frontoffice/components/user_targeting/types';
import { UjErrorBoundary } from 'hb-react/shared/components/ErrorBoundary';

import { NotifyPeopleModal } from './NotifyPeopleModal';

export const NotifyPeopleModalRoot = ({
  renderTriggerElement,
  ...props
}: UserTargetingProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      {renderTriggerElement?.(handleOpen)}

      {isOpen && (
        <UjErrorBoundary
          context={{
            tags: {
              module: 'FO|NotifyPeople',
            },
          }}
        >
          <NotifyPeopleModal
            setIsOpen={setIsOpen}
            onClose={handleClose}
            {...props}
          />
        </UjErrorBoundary>
      )}
    </>
  );
};
